import styled from 'styled-components';

const StyledMedicalDataAccessAuthorizationModalForm = styled.div`
   h3:not(:first-child) {
      margin-top: 36px;
   }
`;

StyledMedicalDataAccessAuthorizationModalForm.displayName = 'StyledMedicalDataAccessAuthorizationModalForm';

export { StyledMedicalDataAccessAuthorizationModalForm };
